import React, { useState, useEffect } from "react";
import axios from "axios";
import jsPDF from "jspdf"; // Import jsPDF
import OrderListTwo from "./OrderListTwo";
import "./ToPackPage.css"; // Ensure to include CSS for hidden filters

const ToPackPage = () => {
  const [couriers, setCouriers] = useState([]); // Couriers data
  const [selectedCourier, setSelectedCourier] = useState(null); // Track selected courier
  const [statusFilter, setStatusFilter] = useState("Approved"); // Default filter: Approved
  const [refreshSignal, setRefreshSignal] = useState(false); // Trigger refresh for OrderListTwo
  const [selectedOrders, setSelectedOrders] = useState([]); // Track selected orders
  const [orders, setOrders] = useState([]); // Store all orders displayed in the table
 
    // NEW: State for the selected date filter (defaults to today, YYYY-MM-DD)
    const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split("T")[0]);

  const [totalApprovedOrders, setTotalApprovedOrders] = useState(0); // ✅ Added totalApprovedOrders state
  // Fetch couriers on component mount
  useEffect(() => {
    axios
      .get("https://astrovidhya.in/api/couriers/active")
      .then((response) => setCouriers(response.data))
      .catch((error) => console.error("Error fetching couriers:", error));
  }, []);


  const ChildComponent = ({ onSelectOrder = () => {} }) => {
    return (
      <button onClick={() => onSelectOrder("Order123")}>
        Select Order
      </button>
    );
  };
  


// ✅ Handle "Total" row click - Show all orders of active couriers
const handleTotalClick = () => {
  setSelectedCourier(null); // Reset courier filter
  setRefreshSignal((prev) => !prev); // Refresh OrderListTwo
  setSelectedOrders([]); // Clear selected orders
};

// Handle date change from the date picker
const handleDateChange = (event) => {
  const selected = event.target.value;
  console.log("📅 Selected Date Changed:", selected);
  setSelectedDate(selected);
};


  // Handle courier selection (filter orders by courier)
  const handleCourierClick = (courierId) => {
    setSelectedCourier(courierId); // Set the selected courier
    setRefreshSignal((prev) => !prev); // Refresh OrderListTwo with the selected courier
    setSelectedOrders([]); // Clear selected orders when switching courier
  };

  // Handle Select All
  const handleSelectAll = () => {
    if (!orders || orders.length === 0) {
      alert("No orders available to select!"); // Prevent errors if orders are empty
      return;
    }
  
    console.log("Selecting all orders:", orders); // Debugging
  
    setSelectedOrders(orders.map((order) => order._id)); // ✅ Select all available orders
  };
  
  

  // Handle Clear All
  const handleClearAll = () => {
    setSelectedOrders([]); // Clear all selected orders
  };

  // Handle Submit (generate PDF and update backend)
 // Handle Submit (confirm selection & update courier totals)
// ✅ Auto Refresh State
const [isUpdating, setIsUpdating] = useState(false);

// Handle Submit (confirm selection & update courier totals)

  

  // Fetch couriers on component mount
  useEffect(() => {
    axios
      .get("https://astrovidhya.in/api/couriers/active")
      .then((response) => {
        setCouriers(response.data);
        setTotalApprovedOrders(
          response.data.reduce((sum, courier) => sum + (courier.totalApproved || 0), 0)
        ); // ✅ Initialize total orders
      })
      .catch((error) => console.error("Error fetching couriers:", error));
  }, []);

  // ✅ Handle Submit - Updates only Courier Table
  const handleSubmit = () => {
    if (selectedOrders.length === 0) {
      alert("No orders selected!");
      return;
    }
  
    axios
      .post("https://astrovidhya.in/api/orders/update-status", {
        orderIds: selectedOrders,
        status: "To Pack",
      })
      .then(() => {
        setSelectedOrders([]); // Clear selected orders
        window.location.reload(); // ✅ Refresh the entire page after confirming selection
      })
      .catch((error) => {
        console.error("Error submitting orders:", error);
      });
  };
  

  // Generate PDF stickers for selected orders
  const generatePDF = () => {
    if (selectedOrders.length === 0) {
      alert("No orders selected!");
      return;
    }

    const pdf = new jsPDF();
    let x = 10,
      y = 10;

    selectedOrders.forEach((orderId, index) => {
      const order = orders.find((o) => o._id === orderId);
      if (order) {
        pdf.text(`Order ID: ${order._id}`, x, y);
        pdf.text(`Customer: ${order.customer_name || "Unknown"}`, x, y + 10);
        pdf.text(`Courier: ${order.courier?.name || "Unknown"}`, x, y + 20);
        pdf.text(`Amount: ₹${order.total_amount || "0"}`, x, y + 30);
        pdf.text(`Status: ${order.approval_status || "N/A"}`, x, y + 40);
      }

      y += 50; // Space for the next sticker
      if ((index + 1) % 4 === 0) {
        pdf.addPage(); // Add a new page after every 4 stickers
        x = 10;
        y = 10;
      }
    });

    pdf.save("Orders_To_Pack.pdf");
  };

  return (
    <div className="to-pack-page p-4">
      <h2 className="text-lg font-bold mb-4">To Pack Page</h2>
  
      {/* Courier Panel */}
      <table className="table-auto w-full border mb-4">
        <thead>
          <tr>
            <th className="border px-2 py-1">Courier Name</th>
            <th className="border px-2 py-1">Total Approved Orders</th>
          </tr>
        </thead>
        <tbody>
    {couriers.map((courier) => (
      <tr
        key={courier._id}
        onClick={() => setSelectedCourier(courier._id)} // ✅ Set selectedCourier on click
        className={`cursor-pointer hover:bg-gray-100 ${
          selectedCourier === courier._id ? "bg-blue-200" : ""
        }`}
      >
        <td className="border px-2 py-1">{courier.name}</td>
        <td className="border px-2 py-1">{courier.totalApproved || 0}</td>
      </tr>
    ))}
    <tr
      onClick={() => setSelectedCourier(null)} // ✅ Reset filter when clicking "Total"
      className="cursor-pointer bg-gray-300 font-bold hover:bg-gray-400"
    >
      <td className="border px-2 py-1">Total</td>
      <td className="border px-2 py-1">
        {couriers.reduce((total, courier) => total + (courier.totalApproved || 0), 0)}
      </td>
    </tr>
  </tbody>

      </table>
    
 
  
      {/* Date Picker Element (aligned right) */}
      <div className="flex justify-end mb-4">
        <label className="py-3 mr-2 font-bold text-gray-700">Select Date:</label>
        <input
          type="date"
          value={selectedDate}
          onChange={handleDateChange}
          className="px-3 py-2 border rounded-md"
        />
      </div>


      {/* Order List */}
      <OrderListTwo
        refreshSignal={refreshSignal} // Trigger refresh when filters change
        statusFilter={statusFilter} // Filter by status
        selectedCourier={selectedCourier}
        couriers={couriers}
        dateFilter={selectedDate} // Pass the selected date as a filter
        courierFilter={selectedCourier} // Filter by selected courier
        setSelectedOrders={setSelectedOrders} // Pass setSelectedOrders
        selectedOrders={selectedOrders} // Pass selected orders
        setOrders={setOrders} // Pass orders for parent state
        toggleOrderSelection={(orderId) => {
          setSelectedOrders((prevSelected) =>
            prevSelected.includes(orderId)
              ? prevSelected.filter((id) => id !== orderId) // Deselect if already selected
              : [...prevSelected, orderId] // Select if not already selected
          );
        pageType="toPack" // ✅ Identify this as the To Pack Page
        }}
      />

  


      {/* Action Buttons */}
      <div className="mt-4 flex space-x-4">
        <button
          onClick={handleSubmit}
          className="bg-[#028ca3] text-white px-4 py-2 rounded w-1/5 ml-4"
        >
          Confirm Selection
        </button>
        <button className="bg-yellow-500 text-white px-4 py-2 rounded w-1/7">
          Reset
        </button>
        <button className="bg-red-500 text-white px-4 py-2 rounded w-1/7">
          Cancel
        </button>
      </div>
    </div>
    
  );
};

export default ToPackPage;
